import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const StoreContext = createContext(null);

export const STORES = {
  silver: {
    key: "silver", label: "Silver", name: "Siyaara Silver", path: "/silver",
    title: "925 Silver Jewellery — Priced by Today's Rate | Siyaara",
    meta: "Handcrafted 925 sterling silver jewellery — rings, earrings, pendants and anklets at transparent, live-rate prices.",
    metal: "silver", productType: "jewellery",
  },
  gold: {
    key: "gold", label: "Gold", name: "Siyaara Gold", path: "/gold",
    title: "9KT Gold & 925 Silver Jewellery — BIS Hallmarked | Siyaara",
    meta: "BIS-hallmarked gold jewellery with a full price breakup on every piece — metal, making, GST. Live gold-rate pricing.",
    metal: "gold", productType: "jewellery",
  },
  coins: {
    key: "coins", label: "Coins", name: "Siyaara Coins", path: "/coins",
    title: "999 Fine Gold & Silver Coins from 25 MG | Siyaara",
    meta: "Handcrafted 999 fine gold and silver coins from just 25 mg — 53 auspicious designs, assay-certified, QR-verifiable.",
    metal: "", productType: "coin",
  },
};

export function StoreProvider({ children }) {
  const [config, setConfig] = useState(null);
  const [collections, setCollections] = useState([]);
  const [offers, setOffers] = useState([]);
  const [store, setStoreState] = useState(() => localStorage.getItem("siyaara_store") || "silver");
  const [pincode, setPincodeState] = useState(() => localStorage.getItem("siyaara_pincode") || "");
  const [searchOpen, setSearchOpen] = useState(false);
  const [wishlistOpen, setWishlistOpen] = useState(false);
  const [storePromptSeen, setStorePromptSeenState] = useState(() => localStorage.getItem("siyaara_store_prompt") === "1");

  const setStore = (s) => {
    if (!STORES[s]) return;
    setStoreState(s);
    localStorage.setItem("siyaara_store", s);
  };
  const setPincode = (p) => {
    setPincodeState(p);
    localStorage.setItem("siyaara_pincode", p);
  };
  const setStorePromptSeen = () => {
    setStorePromptSeenState(true);
    localStorage.setItem("siyaara_store_prompt", "1");
  };

  useEffect(() => {
    api.get("/store/config").then((r) => setConfig(r.data)).catch(() => setConfig({}));
    api.get("/collections").then((r) => setCollections(r.data)).catch(() => {});
    api.get("/offers").then((r) => setOffers(r.data)).catch(() => {});
  }, []);

  // Brand theming: admin-set colour overrides + favicon, applied at runtime.
  useEffect(() => {
    if (!config) return;
    const b = config.brand || {};
    const colors = b.colors || {};
    const root = document.documentElement;
    const hexToRgb = (hex) => {
      const m = /^#?([0-9a-f]{6})$/i.exec(hex);
      if (!m) return null;
      const n = parseInt(m[1], 16);
      return `${(n >> 16) & 255} ${(n >> 8) & 255} ${n & 255}`;
    };
    for (const k of ["brand", "gold", "ivory"]) {
      if (colors[k]) {
        root.style.setProperty(`--${k}`, colors[k]);
        const rgb = hexToRgb(colors[k]);
        if (rgb) root.style.setProperty(`--${k}-rgb`, rgb);
      }
    }
    if (b.favicon) {
      let l = document.querySelector("link[rel~='icon']");
      if (!l) { l = document.createElement("link"); l.rel = "icon"; document.head.appendChild(l); }
      l.href = b.favicon;
    }
  }, [config]);

  return (
    <StoreContext.Provider value={{
      config, collections, offers,
      store, storeDef: STORES[store], setStore,
      pincode, setPincode,
      searchOpen, setSearchOpen,
      wishlistOpen, setWishlistOpen,
      storePromptSeen, setStorePromptSeen,
    }}>
      {children}
    </StoreContext.Provider>
  );
}

export const useStore = () => useContext(StoreContext);
